import { useState, Key, useEffect } from 'react';
import { createModel } from 'hox';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants';
import { ISaleSoFields, IDetailList } from './vrmBillSaleSoType';
import { saleSoService } from './vrmBillSaleSoService';
import { formatNum } from '@/utils/utils';
import moment from 'moment';
import { useVrmSaleRoDetailModel } from '../vrmBillSaleRo/vrmBillSaleRoModel';
import useGlobalModel from '@/model/globalModel';

export type ISaleSoDescType = {
	numAll: number;
	itemNumAll: number;
	totalAll: number;
	discountAll: number;
	receivableAll: number;
	[key: string]: any;
};

export const useVrmSaleSoDetailModel = createModel(function () {
	const initDesc = {
		numAll: 0, //数量
		itemNumAll: 0, //项数
		totalAll: 0, //总计
		discountAll: 0, //折扣,
		receivableAll: 0, //应收
	};
	const {userBranch} = useGlobalModel();
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	const { getVrmTreeNodeName } = useVrmSaleRoDetailModel();
	//查看数据
	//查看详情form
	const [detailLookForm, setDetailLookForm] = useState<ISaleSoFields>({});
	//查看详情列表
	const [detailLookList, setDetailLookList] = useState<IDetailList[]>([]);
	const [lookDesc, setLookDesc] = useState<ISaleSoDescType>(initDesc);

	//设置底部总数展示（查看|编辑|查看）
	useEffect(() => {
		let newDesc: ISaleSoDescType = { ...initDesc };
		detailLookList &&
			detailLookList.forEach((item) => {
				newDesc.numAll += Number(item.num);
				newDesc.totalAll += Number(item.notAmount);
				newDesc.discountAll += Number(item.notAmount) - Number(item.amount);
				newDesc.receivableAll += Number(item.amount);
			});
		if ('favorableAmount' in detailLookForm) {
			newDesc.receivableAll = newDesc.receivableAll - Number(detailLookForm.favorableAmount);
			newDesc.discountAll = newDesc.discountAll + Number(detailLookForm.favorableAmount);
		}
		newDesc.itemNumAll = detailLookList && detailLookList.length;
		setLookDesc(newDesc);
	}, [detailLookList, detailLookForm]);

	//获取一条编辑或查看数据
	const getDetailEditOne = async (id: string) => {
		let { retData } = await saleSoService.one(id,userBranch);
		if (retData) {
			const { details, settleDetails, saleTime, ...from } = retData;
			const newDetails = details?.map((item) => {
				return {
					...item,
					notAmount: +formatNum(Number(item.num) * Number(item.price)),
					termNum: Number(item.num) + Number(item.inventoryNum), //判断编辑数量的条件
					unitName: getVrmTreeNodeName(item.unitCode as string),
				};
			});
			let newFrom = {
				...from,
				saleTime: saleTime ? moment(saleTime) : null,
				vehicleTypeName: getVrmTreeNodeName(from.vehicleTypeCode as string),
				invoiceTypeName: getVrmTreeNodeName(from.invoiceTypeCode as string),
				settlementPartyName: getVrmTreeNodeName(from.settlementPartyCode as string),
				payType: getVrmTreeNodeName(from.payType as string),
				customerTypeName: getVrmTreeNodeName(from.customerTypeCode as string),
				maintenanceTypeName: getVrmTreeNodeName(from.maintenanceTypeCode as string),
			};
			setDetailLookForm(newFrom);
			setDetailLookList((newDetails as IDetailList[]) ?? []);
		}
	};
	const resetLookCatch = async (type?: string) => {
		setDetailLookForm({});
		setDetailLookList([]);
	};
	return {
		initPgCfg,
		detailLookForm,
		detailLookList,
		lookDesc,
		// model
		setDetailLookForm,
		setDetailLookList,
		setLookDesc,
		getDetailEditOne,
		resetLookCatch,
	};
});
